import React from 'react';
import PageWrapper from './PageWrapper';

class DaynaViewScript extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    const ScriptName = this.props.currScriptName;
    const Script = this.props.currScript.replaceAll("&#34;", "\"").replaceAll("&#39;", "\'");
    const Sentences = Script.split(/\d+\./).filter(Boolean); // split text by numbers followed by a dot and filter out empty lines
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <h3>Current Script: {ScriptName}</h3>
        <div className="numbered-list">
        {Sentences.map((Sentences, index) => (
          <div key={index}>
            <span className="number">{index + 1}. </span>
            <span className="text">{Sentences.trim()}</span>
          </div>
        ))}
      </div> 
      </PageWrapper>
    );
  }
}

export default DaynaViewScript;
